import { render, staticRenderFns } from "./ProdspotCol.vue?vue&type=template&id=ea65aa2a&scoped=true"
import script from "./ProdspotCol.vue?vue&type=script&lang=js"
export * from "./ProdspotCol.vue?vue&type=script&lang=js"
import style1 from "./ProdspotCol.vue?vue&type=style&index=1&id=ea65aa2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea65aa2a",
  null
  
)

export default component.exports